const scrollHint = () => {
  new ScrollHint(".js-scroll-hint", {
    i18n: {
      scrollable: "スクロールできます",
    },
  });
};
